/* @ngInject */
export default class LevyRollCtrl {
	constructor(
		$sce,
		$scope,
		$state,
		Utility,
		$timeout,
		$rootScope,
		BuildingsService,
		PagingService,
		FinancialsService,
		LocalStorageService,
		LevyRollService,
		AuthorizationService,
		FinancialSummaryService
	) {
		this.$sce = $sce;
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.BuildingsService = BuildingsService;
		this.PagingService = PagingService;
		this.FinancialsService = FinancialsService;
		this.LocalStorageService = LocalStorageService;
		this.LevyRollService = LevyRollService;
        this.AuthorizationService = AuthorizationService;
		this.FinancialSummaryService = FinancialSummaryService;
		
		this.init();
		this.activate();
	}

	init() {
		this.selectLevytype = 'levyRoll';
		this.isLegalCollectionRollEnabled = this.AuthorizationService.isAuthorized('View Collections Legal Roll');
		this.isConsolidatedLevyRollEnabled = this.AuthorizationService.isAuthorized('View Consolidated Levy Roll');
		this.buildingWorkflowAndFeatures = {};
		this.statusInformation = null;
		this.canFilter = false;
		this.serviceData = undefined;
		this.financialsServiceData = undefined;
		this._switchIsBusyLoading(true);
		this.selectedBuildingRef = '';
		this.selectedBuildingName = '';
		this.filterMonth = undefined;
		this.filterYear = undefined;
		this.today = this.Utility.getFormatedDate(new Date());
		this.selectedDate = this.Utility.getFormatedDate(new Date());
		this.selectedDateYear = this.Utility.getFormatedDate(new Date());
		this.reportModelHeader = '';
		this.onlyShowDebtors = false;
		this.orderByUnitNumber = false;
		this.orderByHighestDebtor = true;
		this.isFilterByMonthActive = true;
		this.isFilterByOnlyShowDebtors = false;
		this.isFilterByOrderByUnitNumber = false;
		this.isFilterByOrderByHighestDebtor = true;
		this.isfilterByShowAllLegalMemos = false;
		this.isfilterByShowAllLegalAccountData = false;

		this.levyRollPaging = this.PagingService;
		this.isPagingNavigationVisible = false;
		this.isPagingNavigationVisibleLegal = false;

		this.isShowAllLegalMemos = false;
		this.isShowAllLegalAccountData = false;
		this.showHideLegalMemos = 'Show all Legal Memos';
		this.showHideLegalAccountData = 'Show Legal Collection Roll';
		this.isInitialized = false;
		this.isSystemPageReset = false;

		this.$scope.$on('selected-building-changed', (event, newValue) => {
			this.onSelectedBuildingChanged(this, newValue);
		});

		this.$scope.$watch(
			'levyRollVm.levyRollPaging.pageNumber',
			() => {
				if (this.isInitialized && !this.isSystemPageReset) {
					this.getLevyRoll();
				}
				this.isSystemPageReset = false;
			},
			true
		);

		this.$scope.$watch(
			'levyRollVm.levyRollPaging.maxPage',
			() => {
				this.isSystemPageReset = true;
				this.levyRollPaging.pageNumber = 1;
			},
			true
		);
		this.$scope.$watch(
			'levyRollVm.levyRollPaging.maxPageLegal',
			() => {
				this.isSystemPageReset = true;
				this.levyRollPaging.pageNumber = 1;
			},
			true
		);
	}

	openFinancials(page) {
		this.saveSelectedDate();
		this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
	}

	saveSelectedDate() {
		const selectedYear = moment(this.filterYear).toDate();
		const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
		this.LocalStorageService.save('selectedReportYear', selectedYear);
		this.LocalStorageService.save('selectedReportMonth', selectedMonth);
	}

	async gotoOldFinancials() {
		const date = moment(this.filterMonth).format('MMM YYYY');
		let nav = `Monthly Financial Statements>${date}`;
		nav = encodeURI(nav);
		this.$state.go('documents', { nav });
	}

	isDesktop() {
		this.LocalStorageService.save('mediaDevice', 'mobile');
		const mediaDevice = this.LocalStorageService.retrieve('mediaDevice');
		if (mediaDevice == 'mobile') {
			return true;
		}

		return false;
	}

	async filterByMonth() {
		if (this.filterMonth !== '' && this.filterMonth) {
			this.resetVariables();
			this.selectedDate = this.Utility.getFormatedDate(this.filterMonth);
			await this.getLevyRoll();
		} else {
			this.serviceData.levyRollData = {};
		}
	}

	async filterByYear() {
		this.filterMonth = '';
		this.serviceData.levyRollData = undefined;
		this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
		await this.getFinancialMonths(this.selectedDateYear);
	}

	filterByOrderByUnitNumber() {
		this.levyRollPaging.pageNumber = 1;

		this.isFilterByMonthActive = false;
		this.isFilterByOnlyShowDebtors = false;
		this.isFilterByOrderByUnitNumber = true;
		this.isFilterByOrderByHighestDebtor = false;
		this.isShowAllLegalMemos = false;

		this.onlyShowDebtors = false;
		this.orderByHighestDebtor = false;
		this.orderByUnitNumber = true;

		this.getLevyRoll();
	}

	filterByOrderByHighestDebtor() {
		this.levyRollPaging.pageNumber = 1;

		this.isFilterByMonthActive = false;
		this.isFilterByOnlyShowDebtors = false;
		this.isFilterByOrderByUnitNumber = false;
		this.isFilterByOrderByHighestDebtor = true;
		this.isShowAllLegalMemos = false;

		this.onlyShowDebtors = false;
		this.orderByHighestDebtor = true;
		this.orderByUnitNumber = false;

		this.getLevyRoll();
	}

	filterByOnlyShowDebtors() {
		this.levyRollPaging.pageNumber = 1;

		this.isFilterByMonthActive = false;
		this.isFilterByOnlyShowDebtors = true;
		this.isFilterByOrderByUnitNumber = false;
		this.isFilterByOrderByHighestDebtor = false;
		this.isShowAllLegalMemos = false;

		this.orderByUnitNumber = false;
		this.onlyShowDebtors = true;
		this.orderByHighestDebtor = false;

		this.getLevyRoll();
	}

	filterByHideAllLegalMemos() {
		this.levyRollPaging.pageNumber = 1;

		this.isFilterByMonthActive = false;
		this.isfilterByShowAllLegalMemos = false;
		this.isfilterByShowAllLegalAccountData = false;
		this.isShowAllLegalMemos = false;

		this.getLevyRoll();
	}

	filterByHideAllLegalAccountData() {
		this.levyRollPaging.pageNumber = 1;

		this.isFilterByMonthActive = false;
		this.isFilterByOnlyShowDebtors = false;
		this.isFilterByOrderByUnitNumber = false;
		this.orderByUnitNumber = false;
		this.onlyShowDebtors = false;
		this.isShowAllLegalMemos = false;

		this.getLevyRoll();
	}

	toggleShowAllLegalMemos() {
		this.canFilter = true;
		this.isShowAllLegalMemos = !this.isShowAllLegalMemos;
	}

	toggleShowAllLegalAccountData() {
		this.isShowAllLegalAccountData = !this.isShowAllLegalAccountData;
		if (this.isShowAllLegalAccountData) {
            this.showHideLegalAccountData = 'Hide Legal Collection Roll';
			this.filterByShowAllLegalAccountData();
		} else {
            this.showHideLegalAccountData = 'Show Legal Collection Roll';
			this.filterByHideAllLegalAccountData();
		}
	}

	toggleFilterByOrderByUnitNumber() {
		this.canFilter = true;
		this.isFilterByOrderByUnitNumber = !this.isFilterByOrderByUnitNumber;
		this.orderByUnitNumber = !this.orderByUnitNumber;
	}

	toggleFilterByOrderByHighestDebtor() {
		this.canFilter = true;

		this.isFilterByOrderByHighestDebtor = !this.isFilterByOrderByHighestDebtor;
		this.isFilterByOrderByUnitNumber = !this.isFilterByOrderByUnitNumber;

		this.orderByHighestDebtor = !this.orderByHighestDebtor;
		this.orderByUnitNumber = !this.orderByUnitNumber;
	}

	toggleFilterByOnlyShowDebtors() {
		this.canFilter = true;
		this.isFilterByOnlyShowDebtors = !this.isFilterByOnlyShowDebtors;
		this.onlyShowDebtors = !this.onlyShowDebtors;
	}

	selectFilter() {
		this.levyRollPaging.pageNumber = 1;
		this.isFilterByMonthActive = false;
		this.getLevyRoll();
	}

	getReport() {
		this.reportModelHeader =
			this.selectedBuildingName + ' - Levy Roll - ' + moment(this.selectedDate).format('MMM YYYY');
		this.FinancialsService
			.getReport(
				this.selectedBuildingRef,
				this.selectedDate,
				3,
				this.reportModelHeader,
				this.orderByUnitNumber,
				this.onlyShowDebtors,
				this.isShowAllLegalMemos,
				this.isShowAllLegalAccountData
			)
			.then(() => { }, (err) => { })
			.finally(() => { });
    }

    getLegalCollectionRollReport() {
        this.reportModelHeader =
            this.selectedBuildingName + ' - Legal Collection Roll Report - ' + moment(this.selectedDate).format('MMM YYYY');
        this.FinancialsService
            .getReport(
                this.selectedBuildingRef,
                this.selectedDate,
                7,
                this.reportModelHeader,
                this.orderByUnitNumber,
                this.onlyShowDebtors,
                this.isShowAllLegalMemos,
                this.isShowAllLegalAccountData
            )
            .then(() => { }, (err) => { })
            .finally(() => { });
    }

	getLegalReport(cardCode) {
		cardCode = `B${this.selectedBuildingRef}${cardCode}`;
		this.FinancialsService.getLegalReport(cardCode).then(() => { }, (err) => { }).finally(() => { });
	}

	getAllLegalReport() {
        var numberOfMonths = document.getElementById("legalReportMonthOptions").value;
        var numberOfDays = numberOfMonths * 30.436875;
         numberOfDays = Math.floor(numberOfDays);

        this.FinancialsService.getAllLegalReport(this.selectedBuildingRef, numberOfDays).then(() => { }, (err) => { }).finally(() => { });
	}

	resetVariables() {
		this.levyRollPaging.pageNumber = 1;
		this.isFilterByMonthActive = true;
		this.isFilterByOnlyShowDebtors = false;
		this.isFilterByOrderByUnitNumber = false;
		this.orderByUnitNumber = false;
		this.onlyShowDebtors = false;
		this.isfilterByShowAllLegalAccountData = false;
	}

	toggleLegalMemos() {
		if (this.isShowAllLegalMemos) {
			const $collapsable = $('ui-view:first-child .levy-roll-page .levy-roll-panel-group .collapse');
            $collapsable.each((i, toggleAllLegalMemos) => {
                const $collapse = $(toggleAllLegalMemos);
				if (!$collapse.hasClass('in')) {
					const $clickable = $($collapse.parent()[0].children[0]);
					$clickable.trigger('click');
				}
			});
			this.filterByShowAllLegalMemos();
		} else {
			const $collapsable = $('ui-view:first-child .levy-roll-page .levy-roll-panel-group .collapse.in');
            $collapsable.each((i, toggleAllLegalMemos) => {
                const $collapse = $(toggleAllLegalMemos);
				const $clickable = $($collapse.parent()[0].children[0]);
				$clickable.trigger('click');
			});
			this.filterByHideAllLegalMemos();
		}
	}

	async activate() {
		this.serviceData = this.LevyRollService;
		this.financialsServiceData = this.FinancialsService;
		this.financialsSummaryServiceData = this.FinancialSummaryService;
		this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

		var buildingName = '';
		const userProfile = this.LocalStorageService.retrieve('userProfile');

		if (userProfile) {
			if (!this.selectedBuildingRef) {
				this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
			}
			const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
				return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
			});

			if (selectedBuilding) {
				buildingName = selectedBuilding.SchemeName;
			}
		}

		this.selectedBuildingName = buildingName;
		if (this.financialsSummaryServiceData.buildingWorkflowAndFeatures= {}) {
			await this.getbuildingWorkflowAndFeatures();						
		} else {
			this.isLegalCollectionRollEnabled = this.financialsSummaryServiceData.buildingWorkflowAndFeatures[1].Data.ViewLegalCollectionsRoll;
			this.isConsolidatedLevyRollEnabled = this.financialsSummaryServiceData.buildingWorkflowAndFeatures[1].Data.ViewConsolidatedLevyRoll;
		}
		await this.getFinancialYears(true);
	}

	onSelectedBuildingChanged(event, schemeRef) {
		this._switchIsBusyLoading(true);
		this.isInitialized = false;
		this.selectedBuildingRef = schemeRef;
		if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
			this.activate();
		}
	}
	async getbuildingWorkflowAndFeatures(){
		this._switchIsBusyLoading(true);

		try {
			await this.financialsSummaryServiceData.getbuildingWorkflowAndFeatures(this.selectedBuildingRef);
			this.buildingWorkflowAndFeatures = this.financialsSummaryServiceData.buildingWorkflowAndFeatures; 
			if(this.buildingWorkflowAndFeatures){
				this.isLegalCollectionRollEnabled = this.financialsSummaryServiceData.buildingWorkflowAndFeatures[1].Data.ViewLegalCollectionsRoll;
				this.isConsolidatedLevyRollEnabled = this.financialsSummaryServiceData.buildingWorkflowAndFeatures[1].Data.ViewConsolidatedLevyRoll;
			}			
		} catch (err) {
			console.error(`Error while loading workflow and features: ${err}`);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	async getFinancialYears(isInit) {
		this._switchIsBusyLoading(true);

		try {
			await this.FinancialsService.getFinancialYears(this.selectedBuildingRef, this.today);
			if (isInit) {
				await this.getSelectedDate(true);
			} else {
				this.filterYear = this.FinancialsService.financialYears[
					(await this.FinancialsService.financialYears.length) - 1
				].WhenTo;
				this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
				await this.getFinancialMonths(this.today);
			}
		} catch (err) {
			console.error(`Error while loading financial years\n${err}`);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}
	async getFinancialMonths(date, isInit) {
		this._switchIsBusyLoading(true);
		try {
			await this.FinancialsService.getFinancialMonths(this.selectedBuildingRef, date || new Date());
			let selectedMonthIndex = -1;

			const selectedDateMonth = await this.FinancialsService.getSelectedMonth();

			if (selectedDateMonth) {
				if (this.FinancialsService.financialMonths && this.FinancialsService.financialMonths.length > 0) {
					const foundMonth = this.FinancialsService.financialMonths.find((month, index) => {
						const momentMonth = moment(month.WhenFrom);
						if (momentMonth.isSame(selectedDateMonth, 'month')) {
							selectedMonthIndex = index;
							return true;
						}
					});

					if (selectedMonthIndex > -1 && foundMonth) {
						this.filterMonth = this.FinancialsService.financialMonths[selectedMonthIndex].WhenFrom;
						this._filterOutFutureMonths();
					}
				}
			} else if (date && isInit) {
				this.FinancialsService.financialMonths.filter(async (month, i) => {
					const monthDateStr = month.WhenFrom.substr(0, 10);
					const monthDate = moment(new Date(monthDateStr), 'YYYY-DD-MM');
					const selectedMonth = await this.FinancialsService.getSelectedMonth();

					if (monthDate.isSame(selectedMonth, 'month')) {
						selectedMonthIndex = i;
						return true;
					}
				});

				if (selectedMonthIndex === -1) {
					this.filterMonth = '';
				} else {
					this.filterMonth = this.FinancialsService.financialMonths[selectedMonthIndex].WhenFrom;
				}
			} else if (isInit) {
				this.filterMonth = this.FinancialsService.financialMonths[
					this.FinancialsService.financialMonths.length - 1
				].WhenFrom;
			}
			if (this.filterMonth) {
				this.selectedDate = this.filterMonth;
				this.isInitialized = true;
				await this.getLevyRoll();
			}
		} catch (err) {
			console.error(`Error while loading financial months\n${err}`);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}
	async getSelectedDate(isInit) {
		const selectedDateYear = await this.FinancialsService.getSelectedYear();
		const selectedDateMonth = await this.FinancialsService.getSelectedMonth();

		if (isInit) {
			for (let i = 0; i < this.FinancialsService.financialYears.length; i++) {
				const yearRaw = this.FinancialsService.financialYears[i];

				if (selectedDateYear.isBetween(yearRaw.WhenFrom, yearRaw.WhenTo)) {
					this.filterYear = this.FinancialsService.financialYears[i].WhenTo;
					this.selectedDateYear = await this.Utility.getFormatedDate(this.filterYear);
					break;
				}
			}

			const date = selectedDateYear ? selectedDateYear : new Date();
			await this.getFinancialMonths(date, true);
		}
	}

	async getLevyRoll() {
		this._switchIsBusyLoading(true);
		this.selectedDate = await this.FinancialsService.getSelectedDate(this.selectedDate);

		await this.serviceData
			.getLevyRoll(
				this.selectedBuildingRef,
				this.selectedDate,
				this.isFilterByOrderByUnitNumber,
				this.isFilterByOnlyShowDebtors,
				this.isfilterByShowAllLegalMemos,
				this.isfilterByShowAllLegalAccountData,
				this.levyRollPaging.pageNumber
			)
			.then(
				async () => {
					this.levyRollPaging.numberOfResults = this.serviceData.numberOfResults;
					this.levyRollPaging.numberOfResultsLegal = this.serviceData.numberOfResultsLegal;

					this.levyRollPaging.limit = 20;

					if (this.levyRollPaging.pageNumber === 1) {
						this.levyRollPaging.firstItemIndex = 1;
						this.levyRollPaging.firstItemIndexLegal = 1;
					} else {
						this.levyRollPaging.firstItemIndex =
							(this.levyRollPaging.pageNumber - 1) * this.levyRollPaging.limit + 1;
						this.levyRollPaging.firstItemIndexLegal =
							(this.levyRollPaging.pageNumber - 1) * this.levyRollPaging.limit + 1;
					}

					this.levyRollPaging.lastItemIndex =
						this.levyRollPaging.firstItemIndex + this.levyRollPaging.limit - 1;

					this.levyRollPaging.lastItemIndexLegal =
						this.levyRollPaging.firstItemIndexLegal + this.levyRollPaging.limit - 1;

					if (this.levyRollPaging.numberOfResults > 0) {
						this.levyRollPaging.maxPage = Math.ceil(
							this.levyRollPaging.numberOfResults / this.levyRollPaging.limit
						);
						if (this.levyRollPaging.maxPage > 1) {
							if (this.levyRollPaging.maxPage === this.levyRollPaging.pageNumber) {
								this.levyRollPaging.lastItemIndex = this.levyRollPaging.numberOfResults;
							}
							this.isPagingNavigationVisible = true;
						} else {
							this.isPagingNavigationVisible = false;
						}
					} else {
						this.levyRollPaging.maxPage = 1;
						this.isPagingNavigationVisible = false;
						this.levyRollPaging.pageNumber = 1;
					}

					if (this.levyRollPaging.numberOfResultsLegal > 0) {
						this.levyRollPaging.maxPageLegal = Math.ceil(
							this.levyRollPaging.numberOfResultsLegal / this.levyRollPaging.limit
						);
						if (this.levyRollPaging.maxPageLegal > 1) {
							if (this.levyRollPaging.maxPageLegal === this.levyRollPaging.pageNumberLegal) {
								this.levyRollPaging.lastItemIndexLegal = this.levyRollPaging.numberOfResultsLegal;
							}
							this.isPagingNavigationVisibleLegal = true;
						} else {
							this.isPagingNavigationVisibleLegal = false;
						}
					}
					else {
						this.levyRollPaging.maxPageLegal = 1;
						this.isPagingNavigationVisibleLegal = false;
						this.levyRollPaging.pageNumberLegal = 1;
					}					
				},
				(err) => { }
			)
			.finally(async () => {
				await this.getFinancialState();
				this.canFilter = false;
				this._switchIsBusyLoading(false);
			});
	}

	async getUnitLegalMemo(UnitItemCode) {
		var panalId = `#${UnitItemCode}`;
		var islegalcollectionroll = document.getElementById("islegalcollectionroll").checked;
		var isconsolidatedlevyroll = document.getElementById("isconsolidatedlevyroll").checked;

		if (islegalcollectionroll && $(`#L-${UnitItemCode}`).hasClass('in')) {
			$(`#L-${UnitItemCode}`).collapse('hide');
		}
		else if ($(`#${UnitItemCode}`).hasClass('in')) { 
			$(panalId).collapse('hide');
		}
		else if (isconsolidatedlevyroll && $(`#C-${UnitItemCode}`).hasClass('in')) {
			$(`#C-${UnitItemCode}`).collapse('hide');
		}
		else {
			this.serviceData.levyRollUnitMemoData = {};
			const schemeRef = this.selectedBuildingRef;
			var CardCode = `B${schemeRef}${UnitItemCode}`;
			this._switchIsBusyLoadingMemo(true);
			await this.serviceData.getUnitLegalMemo(
				CardCode,
				this.selectedDate,
				UnitItemCode
			)
				.then(
					() => {
						if (islegalcollectionroll) {
							$('.collapse.in').collapse('hide');
							panalId = `#L-${UnitItemCode}`;
							$(panalId).collapse('show');
						} else if (isconsolidatedlevyroll) {
							$('.collapse.in').collapse('hide');
							panalId = `#C-${UnitItemCode}`;
							$(panalId).collapse('show');
						}
						else {
							$(panalId).collapse('show');
						}
					}, (err) => { }
				)
				.finally(() => {
					this._switchIsBusyLoadingMemo(false);
				});
		}
	}

	async getFinancialState() {
		const type = 3;
		const schemeRef = this.selectedBuildingRef;
		const momentDate = moment(this.selectedDate, 'YYYY-MM-DD');
		const formattedDate = momentDate.format('YYYY-MM-DD');
		const date = `${formattedDate.substr(0, 8)}01`;

		try {
			const results = await this.FinancialsService.getFinancialState(schemeRef, date, type);

			const { status, message } = results;
			this.statusInformation = message;
		} catch (error) {
			this.NotificationService.error('Error loading levy roll statement status');
		} finally {
		}
	}

	_filterOutFutureMonths() {
		const today = new Date();
		const formatedDate = moment(today).format('YYYY MMMM');
		const currentYear = formatedDate.split(' ')[0];
		const currentMonth = formatedDate.split(' ')[1];

		let foundIndex = -1;
		const found = this.FinancialsService.financialMonths.find((month, index) => {
			const fields = month.FriendlyNameMonth.split(' ');
			const yearStr = fields[1];
			const monthStr = fields[0];
			const found = currentYear === yearStr && currentMonth === monthStr;

			if (found) {
				foundIndex = index;
			}
			return found;
		});

		if (found && foundIndex > -1) {
			const filteredMonths = this.FinancialsService.financialMonths.filter(
				(month, index) => index < foundIndex + 1
			);

			if (filteredMonths && filteredMonths.length < this.FinancialsService.financialMonths.length) {
				this.FinancialsService.financialMonths = filteredMonths;
			}
		}
	}

	allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

	_switchIsBusyLoading(flag) {
		this.$timeout(() => {
			this.isLoading = flag;
		});
	}

	_switchIsBusyLoadingMemo(flag) {
		this.$timeout(() => {
			this.isLoadingMemo = flag;
		})
	}
}
